import { ReportFeatures } from '@hcs/types';

export const COMP_SELECTION_MAP_ID = 'REPORT_API/COMP_SELECTION_MAP';

export const COMP_SELECTION_MAP_FEATURES = [ReportFeatures.CompsSelect];
